import React, { useEffect } from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import POTable from './POTable';
import SearchBar from '../../../Components/Utility/FilterAction/SearchBar';
import { useComponentOrderState } from '../ComponentProvider';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import * as componentAction from '../store/component.action';
import { checkArray } from '../../../Components/helper';
import Loader from '../../../Components/Utility/Loader/Loader';
import { AddIcon, DeleteIcon } from '../../../bombiix-icon';

function POTemplateList() {
  const { Componentstate, handleCheckAll, isallChecked, setComponentState } = useComponentOrderState();
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  useEffect(() => {
    return () => {
      setComponentState((prev) => ({
        ...prev,
        templateListData: [],
        pageIndex: 1,
        hasMore: false,
        searchText: '',
      }));
      dispatch(componentAction.clearReducer());
    };
  }, []);
  const handleCloseDeleteModal = () => {
    setComponentState((prevState) => ({
      ...prevState,
      deletedId: null,
      deleteModal: false,
      deleteMultipleModal: false,
    }));
  };

  const handleMultiDelete = () => {
    setComponentState((prevState) => ({
      ...prevState,
      deleteMultipleModal: true,
    }));
  };

  const handleSingleDelete = (id) => {
    setComponentState((prevState) => ({
      ...prevState,
      deletedId: id,
      deleteModal: true,
    }));
  };

  const confirmDelete = async () => {
    const params = {
      poTemplateLibIds: Componentstate.deletedId,
      multipleDelete: false,
    };
    const response = await dispatch(componentAction.deletePOTemplateList(params, t));

    const reqObj = {
      pageIndex: 1,
      pageSize: Componentstate?.pageSize,
    };
    if (Componentstate.searchText) {
      reqObj.searchText = Componentstate.searchText;
    }

    if (Componentstate.sortOrder) {
      reqObj.sortOrder = Componentstate?.sortOrde;
      reqObj.sortPropertyName = Componentstate?.sortPropertyName;
    }
    if (response) {
      setComponentState((prevState) => ({
        ...prevState,
        templateListData: [],
        selectedTemplate: [],
        pageIndex: 1,
      }));
      await dispatch(componentAction.fetchPOTemplateList(reqObj));
      handleCloseDeleteModal();
    }
  };

  const confirmDeleteMultiple = async () => {
    const jsonString = JSON.stringify(Componentstate.selectedTemplate);
    const formattedString = jsonString.replace(/"/g, '"');
    const objDeleteMulti = {
      poTemplateLibIds: formattedString,
      multipleDelete: true,
    };
    if (checkArray(Componentstate?.selectedTemplate)) {
      const response = await dispatch(componentAction.deletePOTemplateList(objDeleteMulti, t));
      if (response) {
        const reqObj = {
          pageIndex: 1,
          pageSize: Componentstate?.pageSize,
        };
        if (Componentstate.searchText) {
          reqObj.searchText = Componentstate.searchText;
        }

        if (Componentstate.sortOrder) {
          reqObj.sortOrder = Componentstate?.sortOrde;
          reqObj.sortPropertyName = Componentstate?.sortPropertyName;
        }
        setComponentState((prevState) => ({
          ...prevState,
          templateListData: [],
          selectedTemplate: [],
          pageIndex: 1,
        }));

        await dispatch(componentAction.fetchPOTemplateList(reqObj));
        handleCloseDeleteModal();
      }
    }
  };

  const handleTemplateSearch = (value) => {
    setComponentState((prev) => ({
      ...prev,
      searchText: value,
      searchLoaded: true,
    }));
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container max-w-260">
          <h4 className="title w-xs-200px">{t('ADD_PO_TEMPLATE_PROVIDER.PO_TEMPLATES')}</h4>
        </div>
        <div className="search-filter">
          <SearchBar
            placeholder={t('ADD_PO_TEMPLATE_PROVIDER.SEARCH_TEMPLATE')}
            onSearch={(e) => {
              handleTemplateSearch(e.target.value);
            }}
            value={Componentstate.searchText}
          />

          <Link className="filter-btn filter-button_add" to="/component-order/po-template/create-po-template/">
            <AddIcon size={24} />
          </Link>

          <button
            className="filter-btn filter-button_add"
            title={t('ADD_PO_TEMPLATE_PROVIDER.DELETE_ITEM')}
            type="button"
            onClick={() => handleMultiDelete()}
            disabled={!Componentstate?.selectedTemplate.length}
          >
            <DeleteIcon size={24} />
          </button>
          <div className="selectall-checkbox">
            <input type="checkbox" name="selectAll" id="selectAll" onChange={(e) => handleCheckAll(e)} checked={isallChecked} />
            <label htmlFor="selectAll" className="btn btn-white btn-back-lib mb-0">
              <span>
                {isallChecked ? 'Unselect' : 'Select'} {t('ADD_PO_TEMPLATE_PROVIDER.ALL')}
              </span>
            </label>
          </div>
        </div>
      </div>
      {Componentstate?.isLoading ? <Loader /> : <POTable handleSingleDelete={handleSingleDelete} />}
      {Componentstate.deleteModal && (
        <ConfirmationPopup
          onOpen={Componentstate.deleteModal}
          onConfirm={() => confirmDelete()}
          title={t('ADD_PO_TEMPLATE_PROVIDER.DELETE_PO_TEMPLATE')}
          message={t('ADD_PO_TEMPLATE_PROVIDER.DELETE_MESSAGE')}
          toggle={() => handleCloseDeleteModal()}
        />
      )}
      {Componentstate?.deleteMultipleModal && (
        <ConfirmationPopup
          onOpen={Componentstate?.deleteMultipleModal}
          onConfirm={() => confirmDeleteMultiple()}
          title={t('ADD_PO_TEMPLATE_PROVIDER.DELETE_PO_TEMPLATE')}
          message={t('ADD_PO_TEMPLATE_PROVIDER.DELETE_MESSAGE')}
          toggle={() => handleCloseDeleteModal()}
        />
      )}
    </>
  );
}

export default POTemplateList;
